import * as marked from 'marked';

import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationConfig } from '../../../../../../../models/organization-config';
import { DomSanitizer } from '@angular/platform-browser';
import { AccountService } from '../../../../../../../services/account/account.service';


@Component({
  selector: 'app-preview-invite-email-modal',
  templateUrl: './preview-invite-email-modal.component.html',
  styleUrls: ['./preview-invite-email-modal.component.css']
})
export class PreviewInviteEmailModalComponent implements OnInit {
  @Input() orgConfig: OrganizationConfig;

  public primaryColor = '#00B3A7';

  constructor(
    public activeModal: NgbActiveModal,
    public accountService: AccountService,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    if (this.orgConfig.custom_style_primary_color_hex !== '') {
      this.primaryColor = '#' + this.orgConfig.custom_style_primary_color_hex;
    }
  }

  public getRenderedAdditionalText() {
    return this.domSanitizer.bypassSecurityTrustHtml(
      marked.parseInline(
        this.orgConfig.invite_email_additional_text,
        {
          breaks: true
        }
      )
    );
  }
}
